module.exports = __webpack_public_path__ + "img/professions-woman-telecommunicator.e906deee.svg";